import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import pageTitle from 'ember-page-title/helpers/page-title';

<template>
  {{pageTitle "PSLF" prepend=false}}
  <VStack>
    <PageHeader @title={{t "pslf.default_full"}} />
    {{outlet}}
  </VStack>
</template>
